import { StaticBaseDao } from '@/dao';
import { ResultSearchRequest, ResultItem } from '@/objects/generated';

export class ResultDao extends StaticBaseDao {
    public static async GetResults(EventID: number, request: ResultSearchRequest): Promise<ResultItem[]> {
        return this.BaseFetchArray(
            ResultItem,
            `Result/GetResults` + '?' + (EventID == undefined ? '' : `EventID=${EventID}`),
            'POST',
            request,
        );
    }
    public static async GetScroll(EventID: number, request: ResultSearchRequest): Promise<ResultItem[]> {
        return this.BaseFetchArray(
            ResultItem,
            `Result/GetScroll` + '?' + (EventID == undefined ? '' : `EventID=${EventID}`),
            'POST',
            request,
        );
    }
}
